import { FC, useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand, /*$getSelection, $isRangeSelection*/ } from 'lexical';
import { $createInsertReplyNode, InsertReplyNode } from '../nodes/InsertReplyNode';
import { $insertNodeToNearestRoot } from '@lexical/utils';

export const INSERT_REPLY_COMMAND: LexicalCommand<{ message: string, userId: number, userName: string }> = createCommand();

export const InsertReplyPlugin: FC<{
    replyContent: { message: string, userId: number, userName: string } | undefined
}> = ({
    replyContent,
}) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (replyContent) {
            editor.dispatchCommand(INSERT_REPLY_COMMAND, replyContent);
        }
    }, [replyContent, editor]);

    useEffect(() => {
        if (!editor.hasNodes([InsertReplyNode])) {
            throw new Error('InsertReplyPlugin: InsertReplyNode not registered on editor');
        }

        editor.registerCommand(
            INSERT_REPLY_COMMAND,
            (payload: { message: string, userId: number, userName: string }) => {
                const insertReplyNode = $createInsertReplyNode(payload.message, payload.userId, payload.userName);
                $insertNodeToNearestRoot(insertReplyNode);
                //const selection = $getSelection();
                //if (!$isRangeSelection(selection)) {
                //    return false
                //}
                //selection?.insertNodes([insertReplyNode]);

                return true;
            },
            COMMAND_PRIORITY_EDITOR
        )
    }, [editor]);

    return null;
};

export default InsertReplyPlugin;